import { combineReducers } from 'redux'
import { RequestContext } from 'DVWebNodeUtils'
import * as actions from '../actions'

import { reducer as strings, StringIdToString } from './strings'
import { reducer as action, IActionState } from './action'
import { reducer as detail, IDetailState } from './detail'
import { reducer as refund, IRefundState } from './refund'
import { reducer as imdb, TitleIdToImdb } from './imdb'
import { reducer as notification, TitleIdToNotification } from './notification'
import { reducer as seasons, TitleIdToSeasonInfos } from './seasons'
import { reducer as collections, TitleIdToCollections } from './collections'
import { reducer as carousel, TitleIdToCarousel } from './carousel'
import { reducer as customerPreferences, CustomerPreferences } from './customerPreferences'
import { reducer as bundleCarousel, TitleIdToBundleCarousel } from './bundleCarousel'
import { reducer as buyboxTitleId, TitleIdToBuyBoxTitleId } from './buyboxTitleId'
import { reducer as creative, TitleIdToCreative } from './creative'
import { reducer as self, TitleIdToSelf } from './self'
import { reducer as restriction, TitleIdToRestriction } from './restriction'
import { reducer as trailer, TitleIdToTrailer } from './trailer'
import { reducer as watchlist, TitleIdToWatchlist } from './watchlist'
import { reducer as offerAvailableOn, TitleIdToOffer } from './offerAvailableOn'
import { reducer as actionBox, ActionBoxStatus } from './actionBox'
import { reducer as features, FeatureToStatus } from './features'
import { reducer as purchase, PurchaseDetails } from './purchase'
import { reducer as formattedOfferAvailableOn, TitleIdToFormattedOffer } from './formattedOfferAvailableOn'
import { reducer as faq, TitleIdToFaq } from './faq'
import { reducer as contactUs, TitleIdToContactUs } from './contactUs'
import { reducer as scoutBanner, TitleIdToScoutBanner } from './scoutBanner'
import { reducer as castAndCrew, TitleIdToCastAndCrew } from './castAndCrew'
import { reducer as pageLink, TitleIdToPageLink } from './pageLink'
import { reducer as pageTitleId, PageTitleId } from './pageTitleId'
import { reducer as banner, IBannerState } from './banner'
import { reducer as pageContext, PageContext } from './pageContext'
import { reducer as otherFormats, TitleIdToOtherFormats} from './otherFormats'
import { reducer as player, Player } from './player'
import { reducer as deeplinking, Deeplinking } from './deeplinking'
import { reducer as devices, Devices } from './devices'
import { reducer as bottomBar, BottomBar } from './bottomBar'

export interface IDetailPageState {
  readonly pageTitleId: PageTitleId
  readonly requestContext: RequestContext | null
  readonly customerPreferences: CustomerPreferences
  readonly strings: StringIdToString
  readonly features: FeatureToStatus
  readonly pageContext: PageContext
  readonly player: Player

  //title fragments
  readonly action: IActionState
  readonly buyboxTitleId: TitleIdToBuyBoxTitleId
  readonly creative: TitleIdToCreative
  readonly detail: IDetailState
  readonly imdb: TitleIdToImdb
  readonly notification: TitleIdToNotification
  readonly refund: IRefundState
  readonly restriction: TitleIdToRestriction
  readonly self: TitleIdToSelf
  readonly trailer: TitleIdToTrailer
  readonly watchlist: TitleIdToWatchlist
  readonly bundleCarousel: TitleIdToBundleCarousel

  //atf
  readonly banner: IBannerState
  readonly seasons: TitleIdToSeasonInfos
  readonly offerAvailableOn: TitleIdToOffer
  readonly formattedOfferAvailableOn: TitleIdToFormattedOffer
  readonly actionBox: ActionBoxStatus
  readonly bottomBar: BottomBar

  //btf
  readonly collections: TitleIdToCollections
  readonly carousel: TitleIdToCarousel
  readonly pageLink: TitleIdToPageLink
  readonly scoutBanner: TitleIdToScoutBanner
  readonly castAndCrew: TitleIdToCastAndCrew
  readonly otherFormats: TitleIdToOtherFormats
  readonly faq: TitleIdToFaq
  readonly contactUs: TitleIdToContactUs

  //other
  readonly purchase: PurchaseDetails
  readonly deeplinking: Deeplinking
  readonly devices: Devices
}

const reducer = combineReducers<IDetailPageState, actions.DetailPageActions>({
  requestContext: (state = null) => state,
  pageTitleId,
  features,
  pageContext,
  customerPreferences,
  strings,
  player,
  action,
  bundleCarousel,
  buyboxTitleId,
  creative,
  detail,
  imdb,
  notification,
  refund,
  restriction,
  self,
  trailer,
  watchlist,
  seasons,
  offerAvailableOn,
  formattedOfferAvailableOn,
  collections,
  carousel,
  pageLink,
  actionBox,
  purchase,
  faq,
  contactUs,
  scoutBanner,
  castAndCrew,
  otherFormats,
  banner,
  deeplinking,
  bottomBar,
  devices,
})

export default reducer
